import Cookie from 'js-cookie';
import isSupport from '@pro/common/utils/isSupport';

/**
 * 获取登录状态
 * cookie中hik_connect_pro_userlogin是所有子域名共用的，可能仅表示另一子域名已登录
 */
export const getLoginStatus = () => {
  if (isSupport()) {
    return !!Cookie.get('hik_connect_pro_userlogin');
  }
  return !!(Cookie.get('hik_connect_pro_userlogin') && localStorage.getItem('hik_connect_pro_data'));
};

export default getLoginStatus;
